import React from 'react';

const PROJECTS = [
  {
    company: 'AT&T',
    period: 'Oct 2023 – Present',
    role: 'Lead Data & AI Engineer',
    title: 'Enterprise GenAI Network Intelligence Platform',
    description:
      'Architected an AI assistant platform serving thousands of AT&T engineers with real-time network analytics and natural language querying of terabyte-scale datasets.',
    highlight: '99.9% SLA  •  Tens of thousands of queries/day',
    tags: ['LLMs', 'RAG', 'Azure OpenAI', 'Snowflake', 'LangChain'],
    accentColor: '#00A8E0',
  },
  {
    company: 'Michaels',
    period: 'Feb 2022 – July 2023',
    role: 'Machine Learning Engineer II',
    title: 'NLP-Powered Customer Support Chatbot',
    description:
      'Built and deployed a BERT-powered conversational AI with automated retraining pipelines, enabling 24/7 intelligent retail customer support at scale.',
    highlight: '90%+ annotation consistency  •  Always-on serving',
    tags: ['BERT', 'TensorFlow', 'GCP', 'Dialogflow', 'Airflow'],
    accentColor: '#E31837',
  },
  {
    company: 'TEKsystems',
    period: 'May 2018 – Feb 2022',
    role: 'Principal Engineer – AI & Analytics',
    title: 'AI at Enterprise Scale',
    description:
      'Led ML initiatives across industries — including a chatbot for 160,000+ users during a G-Suite migration, medical NER at 92% precision, and C-suite analytics dashboards.',
    highlight: '160K+ users  •  90% pipeline effort reduction',
    tags: ['Dialogflow', 'NER', 'Healthcare AI', 'Google Cloud', 'Tableau'],
    accentColor: '#0066CC',
  },
];

function Projects() {
  return (
    <section className="projects-section">
      <h2 className="section-title">Featured Work</h2>
      <p className="section-subtitle">Real systems. Real scale. Real impact.</p>
      <div className="projects-grid">
        {PROJECTS.map((p) => (
          <div key={p.company} className="project-card">
            <div className="project-card-top">
              <span
                className="project-company-badge"
                style={{ borderColor: p.accentColor, color: p.accentColor }}
              >
                {p.company}
              </span>
              <span className="project-period">{p.period}</span>
            </div>
            <h3 className="project-title">{p.title}</h3>
            <p className="project-role">{p.role}</p>
            <p className="project-description">{p.description}</p>
            <div className="project-highlight">{p.highlight}</div>
            <div className="project-tags">
              {p.tags.map((tag) => (
                <span key={tag} className="tag">
                  {tag}
                </span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Projects;
